<template>
	<div class="text-xs text-base-content ml-1.5">
		<component :is="sharingIcon" class="w-4 h-4 text-base-content"/>
	</div>
</template>

<script lang="ts">
import { LessonPlanCollection } from "@/models/LessonPlanCollection.model";
import { UsersIcon as UsersOutlineIcon } from "@heroicons/vue/24/outline";
import { UsersIcon, GlobeEuropeAfricaIcon } from "@heroicons/vue/24/solid";
import { PropType } from "vue";

export default {
	name: "IconSharedLessonPlanCollection",

	components: {
		UsersOutlineIcon,
		UsersIcon,
		GlobeEuropeAfricaIcon,
	},

	props: {
		collection: {
			type: Object as PropType<LessonPlanCollection>,
			required: true,
		},
	},
	computed: {
		sharingIcon(): any {
			const icons: Record<string, any> = {
				account: UsersOutlineIcon,
				group: UsersIcon,
				everyone: GlobeEuropeAfricaIcon,
			};
			const sharing = this.collection?.sharing;
			return sharing ? icons[sharing] ?? null : null;
		},
	},
};
</script>
